import { SEO } from "../components/SEO";
import { PageHero } from "../components/PageHero";
import { Section, SectionHeader } from "../components/Section";
import { Card } from "../components/Card";
import { CTASection } from "../components/CTASection";
import { INDUSTRIES, INDUSTRY_CATEGORIES } from "../lib/industries";
import { Link } from "react-router-dom";
import { useTranslation } from "../lib/i18n";

export default function IndustriesPage() {
  const { t } = useTranslation();

  return (
    <>
      <SEO
        title="Industries — Sentinel"
        description="Sentinel transforms safety across 38 industries in 8 categories — from public safety and healthcare to defense, manufacturing, and technology."
        canonical="/industries"
        image="https://images.pexels.com/photos/35082106/pexels-photo-35082106.jpeg?auto=compress&cs=tinysrgb&w=1200"
      />
      <PageHero
        eyebrow={t("industries.page.eyebrow")}
        title={t("industries.page.title")}
        description={t("industries.page.description")}
        bgVariant="teal"
        bgImage="https://images.pexels.com/photos/35082106/pexels-photo-35082106.jpeg?auto=compress&cs=tinysrgb&w=1600"
      />

      {INDUSTRY_CATEGORIES.map((category) => {
        const categoryIndustries = INDUSTRIES.filter((i) => i.category === category);
        return (
          <Section key={category} variant={INDUSTRY_CATEGORIES.indexOf(category) % 2 === 0 ? "default" : "subtle"}>
            <SectionHeader
              eyebrow={category}
              title={category}
              center={false}
            />
            <div className="grid grid-3">
              {categoryIndustries.map((industry) => (
                <Link key={industry.slug} to={`/industries/${industry.slug}`} style={{ textDecoration: "none" }}>
                  <Card hover>
                    <div
                      style={{
                        width: "100%",
                        height: "120px",
                        borderRadius: "var(--radius-md)",
                        backgroundImage: `url(${industry.backgroundImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        marginBottom: "1rem",
                        opacity: 0.8,
                      }}
                    />
                    <h3 style={{ fontSize: "1.0625rem", marginBottom: "0.375rem" }}>{industry.name}</h3>
                    <p className="text-muted" style={{ fontSize: "0.875rem", marginBottom: "0.75rem" }}>
                      {industry.tagline}
                    </p>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "0.375rem" }}>
                      {industry.interventions.slice(0, 2).map((iv) => (
                        <span key={iv.title} className="badge badge-accent" style={{ fontSize: "0.75rem" }}>
                          {iv.title}
                        </span>
                      ))}
                    </div>
                  </Card>
                </Link>
              ))}
            </div>
          </Section>
        );
      })}

      <CTASection
        title={t("industries.cta.title")}
        description={t("industries.cta.description")}
        primaryLabel={t("cta.exploreDomains")}
        primaryTo="/domains"
        secondaryLabel={t("cta.viewLicensing")}
        secondaryTo="/licensing"
      />
    </>
  );
}
